import script from "./JaMaterialDeleteCell.vue?vue&type=script&setup=true&lang=js"
export * from "./JaMaterialDeleteCell.vue?vue&type=script&setup=true&lang=js"

import "./JaMaterialDeleteCell.vue?vue&type=style&index=0&id=ecf84a38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf84a38"]])

export default __exports__